export const loaders = {
  OVERLAY: 'OVERLAY',
  TOPBAR: 'TOPBAR'
}
